const DEFAULT_BASE_URL = 'http://localhost:8000';

function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_FINANCIAL_API_URL || '').trim();
  return envUrl ? envUrl.replace(/\/$/, '') : DEFAULT_BASE_URL;
}

const BASE_URL = resolveBaseUrl();

async function get(path) {
  let res;
  try {
    res = await fetch(`${BASE_URL}${path}`, { method: 'GET' });
  } catch {
    throw new Error(
      `Cannot connect to Finance Balances API at ${BASE_URL}. ` +
      'Set REACT_APP_FINANCIAL_API_URL or ensure the backend is running.'
    );
  }
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const d = await res.json();
      if (typeof d.detail === 'string') detail = d.detail;
      else detail = JSON.stringify(d);
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

async function post(path, body) {
  let res;
  try {
    res = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error(
      `Cannot connect to Finance Balances API at ${BASE_URL}. ` +
      'Set REACT_APP_FINANCIAL_API_URL or ensure the backend is running.'
    );
  }
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const d = await res.json();
      if (Array.isArray(d.detail)) {
        detail = d.detail.map(e => `[${Array.isArray(e.loc) ? e.loc.join('→') : e.loc}] ${e.msg}`).join(' | ');
      } else if (typeof d.detail === 'string') {
        detail = d.detail;
      } else {
        detail = JSON.stringify(d);
      }
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

export const fetchLedgerBalance     = (params) => post('/api/v1/ledger/balance',    params);
export const fetchVendorBalance     = (params) => post('/api/v1/vendor/balance',    params);
export const fetchCustomerBalance   = (params) => post('/api/v1/customer/balance',  params);
export const sendFinanceChat        = (params) => post('/api/v1/chat/',             params);
export const fetchFinanceSuggestions = ()      => get('/api/v1/chat/suggestions');
